// 模拟机详情
export default {
    simulator: 'Simulator',
    initialPosition: 'Initial Position',
    altitude: 'Altitude',
    startUp: 'Start Up',
    remainingTime: 'Remaining Time',
    minute: 'Minute',
    offline: 'Offline',
    startSuccess: 'Start Successfully',
    stoppedSuccess: 'Stopped Successfully',
    mapPicking: 'Map Picking',
    endPickup: 'End Pickup',
    tip_FEPI: 'Format error, please input again',
    tip_PELng: 'Please enter longitude',
    tip_PELat: 'Please enter latitude',
    tip_PEA: 'Please enter altitude',
    tip_PETA: 'Please enter the address',
    tip_CFTA: "Can't find the address",
    tip_EBWR: 'Example: Beijing West Railway Station, Fengtai District, Beijing',
}